export enum TechnologyFilterEnum {
  Id = "id",
  Name = "name",
  Business_Area = "businessArea",
  Is_Accessory = "isAccessory"
}
